import React from "react";
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import fundo from "../../assets/fundo-privacidade.jpg";
import logo from "../../assets/login-logo.png";
import iosBadge from "../../assets/google-play-badge.png";
import androidBadge from "../../assets/appstore-badge.png";
import rodapeLogo from "../../assets/logo_virbac.png";

const Sobre: React.FC = () => {
  return (
    <IonPage>
      <IonContent
        fullscreen
        style={{
          "--background": `url(${fundo}) center/cover no-repeat`,
        } as any}
      >
        <div
          style={{
            maxWidth: 900,
            margin: "40px auto",
            background: "rgba(255,255,255,0.7)",
            borderRadius: 12,
            padding: 32,
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
          }}
        >
          {/* Logo */}
          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <img
              src={logo}
              alt="Virbac no Campo"
              style={{ maxWidth: 320 }}
            />
          </div>

          {/* Sobre */}
          <h2 style={{ opacity: 0.6, fontWeight: 700 }} >Sobre</h2>
          <p>
            <strong>Virbac no Campo</strong> é um aplicativo para controlar,
            monitorar e cadastrar a venda de produtos da Virbac voltados para
            animais de grande porte. O Usuário da Plataforma são os promotores
            de venda, que gerenciam a Plataforma e podem imputar dados de
            terceiros, quais sejam veterinários, clientes e/ou contatos de
            clientes.
          </p>

          <p>O acesso será validado e concedido pelo time de Demanda.</p>
          <p>O aplicativo é gratuito, não há custo para utilizar o app.</p>

          {/* Como acessar */}
          <h2 style={{ marginTop: 24, opacity: 0.6, fontWeight: 700 }}>Como acessar</h2>
          <p>
            O acesso deverá ser solicitado através da opção "Quero me cadastrar"
            do aplicativo. Após o envio, a solicitação será verificada e as
            instruções de acesso serão enviadas para o email indicado.
          </p>

          <p>
            O único dado pessoal que solicitamos é o email e telefone celular.
          </p>

          {/* Link web */}
          <div style={{ textAlign: "center", marginTop: 20 }}>
            <a
              href="https://vbnocampo.com.br/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Virbac no Campo Web
            </a>
            <div style={{ fontSize: 12, color: "#666" }}>
              Acesso direto pelo navegador
            </div>
          </div>

          {/* Stores */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 30,
              gap: 20,
              flexWrap: "wrap",
            }}
          >
            <a href="https://play.google.com/store/apps/details?id=br.com.virbac.v2.vetexperts">
              <img
                src={androidBadge}
                alt="Google Play"
                style={{ height: 60 }}
              />
            </a>
            
            <a href="https://apps.apple.com/br/app/virbac-no-campo/id1480432960">
              <img
                src={iosBadge}
                alt="App Store"
                style={{ height: 60 }}
              />
            </a>
          </div>

          {/* Política */}
          <div style={{ textAlign: "center", marginTop: 30 }}>
            <a href="/privacidade.pdf">Nossa política de privacidade</a>
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: 20 }}>
          <img src={rodapeLogo} alt="Virbac no Campo" style={{ height: 100 }} />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Sobre;